"use client";
import React from "react";
// import { useEvent } from "@/contexts/EventContext";
import {
  useWebinarSchedule,
  useWebinarScheduleLoading,
} from "@/contexts/EventContext";
import {
  getWebinarEntry,
  getOrdinalDateParts,
  isWebinarEntryUpcoming,
} from "@/data/webinarSchedule";
import WebinarDateSkeleton from "@/components/common/WebinarDateSkeleton";

interface EventTickerProps {
  pageName?: string;
}

const EventTicker: React.FC<EventTickerProps> = () =>
  // { pageName = "CAIRA" }
  {
    // const latestEvent = useEvent(pageName);
    // const formattedDate = latestEvent?.formattedDate
    //   ? latestEvent.formattedDate.split(" ").slice(0, 2).join(" ")
    //   : "";
    // const time = latestEvent?.time ? latestEvent?.time : "4:00 PM";
    // const day = latestEvent?.day ? latestEvent?.day : "Saturday";

    const webinarSchedule = useWebinarSchedule();
    const isScheduleLoading = useWebinarScheduleLoading();
    const weeklyWebinarEntry = getWebinarEntry("weekly", webinarSchedule);
    const dateParts = getOrdinalDateParts(weeklyWebinarEntry.date);
    // Past session (e.g. Strapi down, static fallback is stale): show generic
    // copy rather than announcing a date that has already gone by.
    const isUpcoming = isWebinarEntryUpcoming(weeklyWebinarEntry);

    return (
      <>
        {/* mobile */}
        <div
          className="md:hidden block"
          style={{ minHeight: "24px", contain: "layout style paint" }}
        >
          <div className="rightTI w-full">
            <a href="/accounting/events/webinar">
              <p
                className="text-[#FFF] font-normal animated_text_mob"
                style={{ lineHeight: "20px", minHeight: "20px" }}
              >
                <span className="font-bold">
                  AI in Accounting 101: Build your own 1st AI-Agent in 2 hours
                </span>{" "}
                |{" "}
                <span className="inline-flex items-center">
                  <span className="inline-block w-2 h-2 bg-[#f33] rounded-full mr-1" />
                  <span className="text-[#f33] font-bold">Live:</span>{" "}
                  <span className="ml-1 text-white font-bold">
                    {isScheduleLoading ? (
                      <WebinarDateSkeleton width={150} />
                    ) : isUpcoming ? (
                      <>
                        On {dateParts.day}
                        <sup>{dateParts.suffix}</sup>{" "}
                        {dateParts.month.slice(0, 3)}, {weeklyWebinarEntry.day}{" "}
                        at
                      </>
                    ) : (
                      "Check upcoming sessions"
                    )}
                  </span>{" "}
                  <span
                    className="ml-1 text-[#39f] font-bold"
                    style={{ lineHeight: "20px" }}
                  >
                    {!isScheduleLoading &&
                      isUpcoming &&
                      weeklyWebinarEntry.time}
                  </span>
                </span>
                <span className="px-1">|</span>
                <span style={{ fontWeight: 700, lineHeight: "20px" }}>
                  Register Now
                </span>
              </p>
            </a>
          </div>
        </div>
        {/* desktop */}
        <div
          className="md:block hidden"
          style={{ minHeight: "24px", contain: "layout style paint" }}
        >
          <div className="rightTI w-full">
            <a href="/accounting/events/webinar">
              <p
                className="ticker-wrapper text-[#FFF] font-normal animated_text_mob"
                style={{ lineHeight: "20px", minHeight: "20px" }}
              >
                <span className="font-semibold">
                  AI in Accounting 101: Build your own 1st AI-Agent in 2 hours
                </span>
                <span className="px-4">|</span>
                <span className="text-[#333] text-sm font-semibold leading-normal mt-1">
                  <span className="inline-block w-2 h-2 bg-[#f33] rounded-full mr-1" />
                  <span className="text-[#f33] font-semibold">Live:</span>{" "}
                  <span className="text-[#fff] font-semibold">
                    {isScheduleLoading ? (
                      <WebinarDateSkeleton width={150} />
                    ) : isUpcoming ? (
                      <>
                        On {dateParts.day}
                        <sup>{dateParts.suffix}</sup>{" "}
                        {dateParts.month.slice(0, 3)}, {weeklyWebinarEntry.day}{" "}
                        at
                      </>
                    ) : (
                      "Check upcoming sessions"
                    )}
                  </span>{" "}
                  <span className="text-white font-bold">
                    {!isScheduleLoading &&
                      isUpcoming &&
                      weeklyWebinarEntry.time}
                  </span>
                </span>
                <span className="px-4">|</span>
                <span style={{ fontWeight: 700, lineHeight: "20px" }}>
                  Register Now
                </span>
              </p>
            </a>
          </div>
        </div>
      </>
    );
  };

export default EventTicker;
